import { render, staticRenderFns } from "./docsmartDashboard.vue?vue&type=template&id=196a74f0&"
import script from "./docsmartDashboard.vue?vue&type=script&lang=js&"
export * from "./docsmartDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports